import { Injectable } from '@angular/core';
import { ApiUrlService } from '../shared-services/api-url.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private apiUrlService:ApiUrlService, private http:HttpClient) { }


 
  getAdminDashboard(payload: any):Observable<any> {
    return this.http.post<any>(this.apiUrlService.GET_DASHBOARD_CHART, payload);
  }
}
